/*=============================================================================================
*
*      JS for carousel for articles/news/posts
*      Carousel is located in partials/carousels/blog-simple-carousel.html
*      CSS and JS are loaded through respective Assets/main files
*       Author: ABLE Dev
==============================================================================================*/

import Swiper from 'swiper';

import SwiperCore, { Pagination, Navigation } from 'swiper/core';

SwiperCore.use([ Pagination, Navigation ]);

export function articleSimpleSlider() {
    var swiper = new Swiper(".article-simple-slider", {
        slidesPerView: "auto",
        centeredSlides: true,        
        loop: true,
        navigation: {
            nextEl: ".article-slider-button-next",
            prevEl: ".article-slider-button-prev",
        },
        pagination: {
            el: ".article-slider-pagination",
        }
    });
};